export default "__VITE_ASSET__CJNQsnvw__"